import script from "./form-plan.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-plan.vue?vue&type=script&setup=true&lang=ts"

import "./form-plan.vue?vue&type=style&index=0&id=e427d0b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e427d0b0"]])

export default __exports__